import { createSlice } from '@reduxjs/toolkit';
import { StaticData } from '../../config/enum/staticData';

type IStaticData = {
    [StaticData.TEMPERATURE]: {
        minValue: number;
        maxValue: number;
    };
    [StaticData.PRIVACY_POLICY]: {
        emailId: string;
        privacyPolicyLink: string;
    };
};

const initialState: IStaticData = {
    [StaticData.TEMPERATURE]: {
        minValue: 105,
        maxValue: 135,
    },
    [StaticData.PRIVACY_POLICY]: {
        emailId: 'support@WATTER.com',
        privacyPolicyLink: 'https://www.watter.com/privacy-policy',
    },
};
const StaticDataSlice = createSlice({
    name: 'staticDataSlice',
    initialState,
    reducers: {
        updateStaticStateData: (state, action) => {
            const { payload } = action;
            const { key, value } = payload;
            return {
                ...state,
                [key]: value,
            };
        },
        resetStaticStateData: () => {
            return initialState;
        },
    },
});

const { reducer, actions } = StaticDataSlice;
export const { updateStaticStateData, resetStaticStateData } = actions;
export { reducer as staticDataReducer };
